import BigNumber from 'bignumber.js';
import { DlVault } from 'types/contracts';

export interface GetNetworkRewardRecordDetailedInput {
  dlVaultContract: DlVault;
  accountAddress: string;
  index: number;
}

export type GetNetworkRewardRecordDetailedOutput = {
  fromUser: string;
  totalAmount: BigNumber;
  claimedAmount: BigNumber;
  startTime: number;
  endTime: number;
  dailyAmount: BigNumber;
  active: boolean;
  generation: number;
  requiredReferrals: number;
  pausedTime: number;
  resumeTime: number;
  releasedDays: number;
  unreleasedDays: number;
  releasedAmount: BigNumber;
  unreleasedAmount: BigNumber;
  claimableAmount: BigNumber;
  totalDays: number;
  canRelease: boolean;
};

const getNetworkRewardRecordDetailed = async ({
  dlVaultContract,
  accountAddress,
  index,
}: GetNetworkRewardRecordDetailedInput): Promise<GetNetworkRewardRecordDetailedOutput> => {
  const result = await dlVaultContract.methods
    .getNetworkRewardRecordDetailed(accountAddress, index)
    .call();

  return {
    fromUser: result.fromUser || result[0] || '',
    totalAmount: new BigNumber(result.totalAmount || result[1] || '0'),
    claimedAmount: new BigNumber(result.claimedAmount || result[2] || '0'),
    startTime: parseInt(result.startTime || result[3] || '0', 10),
    endTime: parseInt(result.endTime || result[4] || '0', 10),
    dailyAmount: new BigNumber(result.dailyAmount || result[5] || '0'),
    active: Boolean(result.active !== undefined ? result.active : result[6]),
    generation: parseInt(result.generation || result[7] || '0', 10),
    requiredReferrals: parseInt(result.requiredReferrals || result[8] || '0', 10),
    pausedTime: parseInt(result.pausedTime || result[9] || '0', 10),
    resumeTime: parseInt(result.resumeTime || result[10] || '0', 10),
    releasedDays: parseInt(result.releasedDays || result[11] || '0', 10),
    unreleasedDays: parseInt(result.unreleasedDays || result[12] || '0', 10),
    releasedAmount: new BigNumber(result.releasedAmount || result[13] || '0'),
    unreleasedAmount: new BigNumber(result.unreleasedAmount || result[14] || '0'),
    claimableAmount: new BigNumber(result.claimableAmount || result[15] || '0'),
    totalDays: parseInt(result.totalDays || result[16] || '0', 10),
    canRelease: Boolean(result.canRelease !== undefined ? result.canRelease : result[17]),
  };
};

export default getNetworkRewardRecordDetailed; 